import { Translatable } from "@icc/shared/helpers";

export class RoundReel {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    /** Kod do wydruków */
    printCode: string;
    @Translatable({ model: 'Profiles' })
    name: string;
    /** Zdjęcie */
    img: string;
    /** Opis */
    description: string;
    /** Przypisane typy produktu */
    shutterTypesIds: number[];
    /** Waga */
    weight?: number;
    /** Max szerokość rolety [mm] */
    maxWidth?: number;
    /** Pasujące pancerze */
    profilesIds?: number[];
    /** Czy domyślny */
    isDefault?: boolean;
}